import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import {
  toasterApi,
  type DownloadCoPilotSessionExport,
} from '@terra/ui-design-system';
import { useCoPilotExportChatTitle } from './useCoPilotExportChatTitle';
import {
  downloadCoPilotSessionExport,
  resolveCoPilotExportErrorMessage,
} from './co-pilot-session-export';

export function useCoPilotSessionExportDownload(
  threadId?: string,
): DownloadCoPilotSessionExport {
  const chatTitle = useCoPilotExportChatTitle(threadId);
  const tToolbar = useTranslations('chat.copilot.toolbar');

  return useCallback<DownloadCoPilotSessionExport>(
    async ({
      format,
      threadId: exportThreadId,
      applicationId,
      sessionStatus,
      requestFilename,
      attachmentFilename,
      csvObjectKinds,
      csvSources,
      csvKind,
      markdownKind,
    }) => {
      try {
        await downloadCoPilotSessionExport({
          format,
          threadId: exportThreadId,
          applicationId,
          status: sessionStatus ?? 'completed',
          chatTitle,
          requestFilename,
          attachmentFilename,
          csvObjectKinds,
          csvSources,
          csvKind,
          markdownKind,
        });
      } catch (error: unknown) {
        toasterApi.error({
          title: resolveCoPilotExportErrorMessage({
            error,
            fallback: tToolbar('exportError'),
            emptyMessage: tToolbar('exportEmpty'),
          }),
        });
      }
    },
    [chatTitle, tToolbar],
  );
}
